module.exports = __webpack_public_path__ + "img/oddnary-purple-scheme.fcee2066.jpg";